import { useQuery } from "@tanstack/react-query";
import {
  fetchTaskChecklistAssignmentRows,
  type TaskChecklistAssignmentRow,
} from "@/lib/taskChecklistAssignmentRows";

export type { TaskChecklistAssignmentRow };

/**
 * Fetches per-checklist assignments for a task (cleaning_task_checklist_assignments).
 * Returns checklist name + assignee label for each. No limit.
 */
export function useTaskChecklistAssignments(taskId: string | undefined) {
  return useQuery({
    queryKey: ["task-checklist-assignments", taskId],
    queryFn: () => fetchTaskChecklistAssignmentRows(taskId!),
    enabled: !!taskId,
    staleTime: 60_000,
  });
}
